import CryptoJS from 'crypto-js';
import Cookies from 'js-cookie';
import TokenService from "../services/token.service";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { differenceInMinutes } from 'date-fns';
import { getConfig } from './config';

const SECRET_KEY = 'N`3"p2Kc7[psy)X'; 

export const estados = {
    "AC": "Acre",
    "AL": "Alagoas",
    "AP": "Amapá",
    "AM": "Amazonas",   
    "BA": "Bahia",
    "CE": "Ceará",
    "DF": "Distrito Federal",
    "ES": "Espírito Santo",
    "GO": "Goiás",
    "MA": "Maranhão",   
    "MT": "Mato Grosso",
    "MS": "Mato Grosso do Sul",
    "MG": "Minas Gerais",
    "PA": "Pará",
    "PB": "Paraíba",
    "PR": "Paraná", 
    "PE": "Pernambuco",
    "PI": "Piauí",
    "RJ": "Rio de Janeiro",
    "RN": "Rio Grande do Norte",
    "RS": "Rio Grande do Sul",
    "RO": "Rondônia",   
    "RR": "Roraima",
    "SC": "Santa Catarina",
    "SP": "São Paulo",
    "SE": "Sergipe",
    "TO": "Tocantins"
};  



export const MidiasContato = {
    "sms": "SMS",
    "email": "E-mail",
    "whatsapp": "Whatsapp",
    "telefone": "Telefone",
    "streaming": "Streaming",
    "manuseio": "Manuseio"
};

export const areasEmailLog = {
    "atendimento_etapa": "Atendimento / Etapa",
    "regua_comunicacao": "Régua de Comunicação",
    "programa_regra": "Regra do Programa",
    "farmacovigilancia_pdf": "Farmacovigilância PDF",
    //"atendimentos_relatos": "Relatos de Atendimento",
};

export const tiposMensagem = {
    "padrao": "Padrão",
    "retorno": "Retorno",
    "cancelamento": "Cancelamento",
};

export const MidiasAceita = {
    "email": "E-mail",
    "whatsapp": "Whatsapp",
    "telefone": "Telefone"
};

export const unidadesDosagens = {
    "unidade": "Unidade",
    "ml": "ml",
    "g": "g",
    "mg": "mg",
}

export const formataDataExibicao = (data) => {
    if(!data){
        return '';
    }

    const data_obj = new Date(data + 'Z');
    const dataFormatada = data_obj.toLocaleString("pt-BR", { timeZone: 'UTC' });
    
    return dataFormatada.slice(0, 10);
}

export function getDataAtualLocalISO() {
    const agora = new Date();
    const offset = agora.getTimezoneOffset() * 60000; // diferença do fuso em milissegundos
    const localISOTime = new Date(agora - offset).toISOString().slice(0, 16);
    return localISOTime;
}

/*export const formataDataHoraExibicao = (data) => {
    if(!data){
        return '';
    }

    const data_obj = new Date(data);
    const dataFormatada = data_obj.toLocaleString("pt-BR", { timeZone: 'UTC' });
    
    return dataFormatada.slice(0, 17) + 'h';
}*/

export const formataDataHoraExibicao = (data) => {
    if (!data) {
        return '';
    }

    // Cria um objeto Date interpretando 'data' como UTC
    const data_obj = new Date(data + 'Z'); // Adiciona 'Z' para indicar que está em UTC

    // Formata a data no fuso horário UTC para garantir que não haverá conversão
    const dataFormatada = data_obj.toLocaleString("pt-BR", { timeZone: 'UTC' });
    
    // Retorna a data formatada cortando para se ajustar ao formato desejado e adicionando 'h'
    return dataFormatada.slice(0, 17) + 'h';
}

// Mapeia o status de envio de e-mail para uma variante de Badge do Bootstrap.
// Retorna { bg, text } pronto para uso em <Badge bg={bg} text={text}>.
export const statusEmailBadge = (status) => {
    const s = String(status || '').toLowerCase().trim();
    let bg = 'secondary';

    if (s) {
        if (/(entregue|delivered|confirmad|sucesso|success)/.test(s)) {
            bg = 'success';
        } else if (/(bounce|devolv|falha|erro|error|rejeit|reject|reclam|complaint|spam|fail)/.test(s)) {
            bg = 'danger';
        } else if (/(pendente|pending|aguard|process|deferr|deferid|adiad|fila|queued)/.test(s)) {
            bg = 'warning';
        } else if (/(enviado|sent|aberto|open|clic|click)/.test(s)) {
            bg = 'info';
        }
    }

    const text = ['warning', 'info', 'light'].includes(bg) ? 'dark' : undefined;

    return { bg, text };
};

export const formataDataApi = (data) => {
    if(!data){
        return '';
    }

    data = data.slice(0, 10)

    let parts = data.split('/');    
    let data_obj = new Date(parts[2], parts[1] - 1, parts[0]);     
    
    return data_obj.toISOString().slice(0, 10);
}  

export function getDataAtual() {
    const agora = new Date();
    const opcoes = { timeZone: 'America/Sao_Paulo', hour12: false };
    const dataHoraSaoPaulo = agora.toLocaleString('pt-BR', opcoes).replace(/\//g, '-').replace(',', '');

    // Formatar a data para YYYY-MM-DD HH:MM:SS
    const dataFormatada = dataHoraSaoPaulo.split(' ')[0].split('-').reverse().join('-');
    const horaFormatada = dataHoraSaoPaulo.split(' ')[1];
    const dataHoraAtualFormatada = `${dataFormatada} ${horaFormatada}`;

    return dataHoraAtualFormatada;
}

export function getDataAtualSemSegundos() {
    const agora = new Date();
    const opcoes = {
        timeZone: 'America/Sao_Paulo',
        hour12: false,
        hour: '2-digit',
        minute: '2-digit'
    };
    const dataHoraSaoPaulo = agora.toLocaleString('pt-BR', opcoes).replace(/\//g, '-').replace(',', '');

    // Formatar a data para YYYY-MM-DD HH:MM
    const dataFormatada = dataHoraSaoPaulo.split(' ')[0].split('-').reverse().join('-');
    const horaFormatada = dataHoraSaoPaulo.split(' ')[1];
    const dataHoraAtualFormatada = `${dataFormatada} ${horaFormatada}`;

    return dataHoraAtualFormatada;
}

export function extrairDataDatetime(data_time) {
    if(!data_time){
        return ''
    }

    const data = data_time.split('T')[0];
    return data;
}

export function formataCNPJ(numero) {
    if(!numero){
        return ''
    }

    numero = numero.replace(/\D/g, '');

    if (numero.length === 11) {
        return numero.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else if (numero.length === 14) {
        return numero.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    } else {
        return numero;
    }
}

export function validaSenha(senha) {
    const regex = {
        comprimento: /.{8,}/, // verifica se tem pelo menos 8 caracteres
        maiuscula: /[A-Z]/,   // verifica se tem pelo menos uma letra maiúscula
        minuscula: /[a-z]/,   // verifica se tem pelo menos uma letra minúscula
        numero: /[0-9]/,      // verifica se tem pelo menos um número
        especial: /[^A-Za-z0-9]/ // verifica se tem pelo menos um caractere especial
    };

    return regex.comprimento.test(senha) &&
           regex.maiuscula.test(senha) &&
           regex.minuscula.test(senha) &&
           regex.numero.test(senha) &&
           regex.especial.test(senha);
}

export function formataCPF(numero) {
    if(!numero) return '';
    numero = numero.replace(/\D/g, '');

    if (numero.length === 11) {
        return numero.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    } else {
        return numero;
    }
}

export function validaCPF(cpf) {
    if (!cpf) return false;

    // Remove caracteres não numéricos
    cpf = cpf.replace(/[^\d]+/g, '');

    // Verifica se tem 11 dígitos
    if (cpf.length !== 11) return false;

    // Verifica se todos os dígitos são iguais (ex.: 111.111.111-11)
    if (/^(\d)\1+$/.test(cpf)) return false;

    // Validação do primeiro dígito verificador
    let soma = 0;
    for (let i = 0; i < 9; i++) {
        soma += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(9))) return false;

    // Validação do segundo dígito verificador
    soma = 0;
    for (let i = 0; i < 10; i++) {
        soma += parseInt(cpf.charAt(i)) * (11 - i);
    }
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(cpf.charAt(10))) return false;

    return true;
}

export function formatarValorAPISemDecimais(valor) {
    valor = valor.split('.');
    return valor[0];
}


export function formatarValorAPI(raw) {
    if (raw == null || raw === '') return 0;
    const s = String(raw).replace(/[^\d.,-]/g, '');
    const sep = Math.max(s.lastIndexOf(','), s.lastIndexOf('.'));
    const nStr = sep > -1
      ? s.slice(0, sep).replace(/[.,]/g, '') + '.' + s.slice(sep + 1)
      : s;
    const n = parseFloat(nStr);
    return isNaN(n) ? '0' : n.toString();
}
  

export function formatarValor(valor) {
    // Remove tudo que não é número
    if(!valor) return '';
    // Convert to string if valor is a number
    if (typeof valor === 'number') {
        valor = valor.toString();
    }
    let valorNumerico = valor.replace(/\D/g, "");

    // Garante que o valor tenha pelo menos 3 dígitos, preenchendo com zeros à esquerda se necessário
    valorNumerico = valorNumerico.padStart(3, '0');

    // Formata os dois últimos dígitos como centavos
    valorNumerico = valorNumerico.slice(0, -2) + "," + valorNumerico.slice(-2);

    // Adiciona os separadores de milhar
    valorNumerico = valorNumerico.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    // Remove o zero à esquerda se o número é menor que 10
    if (valorNumerico.startsWith("0") && valorNumerico.charAt(1) !== ',') {
        valorNumerico = valorNumerico.substring(1);
    }

    return valorNumerico;
}

export function formatarValorLocal(valor) {
    return parseFloat(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

export const mascaras_disponiveis = [
    'prefill[data_atual]',
    'prefill[pais-brasil]',

    //dadosUsuarios
    'prefill[email_usuario]',
    'prefill[pessoa_preencheu]',

    'prefill[nome_medicamento]',
    
    // extra_valores_list
    'prefill[data_inicio_terapia]',
    'prefill[dose]',
    'prefill[freq_aplicacao]', 
    'prefill[apresentacao]',

    //dados_medicos 
    'prefill[medico_prescritor]', 
    'prefill[medico_registro]', 
    'prefill[medico_registro_uf]', 

    // dados_programa
    'prefill[telefone_formulario]',

    // dados_beneficiario
    'prefill[nome_paciente]',
    'prefill[data_nascimento]',
    'prefill[sexo_beneficiario]',
    'prefill[peso_beneficiario]',
    'prefill[altura_beneficiario]',

    // exibe imagem abaixo do campo (informe o caminho da imagem entre colchetes)
    'imagem-auxiliar[...]',
];

export const tiposCampos = {
    texto: "Texto",
    numero: "Número",
    area_texto: "Área de Texto",
    selecao: "Seleção",
    checkbox: "Checkbox",
    radio: "Radio",
    data: "Data",
    arquivo: "Arquivo",
    repeater: "Repetidor",
    gotoconnect: "GoTo Connect",
    voltar_etapa: "Voltar Etapa",
    cancela_atendimento: "Cancela Atendimento",
    motivo_cancelamento: "Motivo Cancelamento",
    informacao: "Informação",
};

export const tiposRepeater = {
    texto: "Texto",
    numero: "Número",
    area_texto: "Área de Texto",
    selecao: "Seleção",
    checkbox: "Checkbox",
    radio: "Radio",
    data: "Data",
    arquivo: "Arquivo",
    gotoconnect: "GoTo Connect",
    voltar_etapa: "Voltar Etapa",
    cancela_atendimento: "Cancela Atendimento",
    motivo_cancelamento: "Motivo Cancelamento",
    informacao: "Informação",
};


export const tiposMidias = {
    "SMS" : "SMS",
    "E-mail" : "E-mail",
    "Whatsapp" : "Whatsapp",
    "Telefone" : "Telefone",
    "Streaming" : "Streaming"
};

export const destinatariosMensagem = {
    medico: "Médico",
    laboratorio: "Laboratório",
    paciente: "Paciente",
};

export const origemReceptivo = {
    medico: "Médico",
    laboratorio: "Laboratório",
    paciente: "Paciente",
    responsavel: "Responsável legal/Cuidador",
    outro: "Outro"
};

export const statusAtendimento = {
    em_andamento: "Em Andamento",
    aguardando: "Aguardando",
    concluido: "Concluído",
    parado: "Parado",
    cancelado: "Cancelado",
};

export const tiposCancelamento = {
    somente_etapa: "Cancelar Somente Etapa",
    definitivo: "Cancelar Atendimento em Definitivo",
};

export const papeisAssinatura = {
    "Paciente": "Paciente",
    "Médico": "Médico",
    "Laboratório": "Laboratório",
};

export const responsaveisEtapas = {
    //cliente: "Cliente",
    "operador": "Operador Aditus",
    //gestor: "Gestor",
    //beneficiario: "Beneficiário",
    "medicos": "Médico",
    "assessor_tecnico": "Assessor Técnico",
    "multiprofissionais": "Multiprofissional",
    //farmacias: "Farmácia",
    "hospitais": "Hospital",
    "clinicas": "Clínica",
    "laboratorio_diagnostico": "Laboratório de Diagnósticos",
    "cooperativas_saude": "Cooperativa de Saúde",
    "motoristas": "Transporte",
    "logistica": "Logística",
    //fornecedor: "Fornecedor",
};

export const tiposUsuarioBotoes = {
    //cliente: "Cliente",
    "operador": "Operador Aditus",
    //gestor: "Gestor",
    //beneficiario: "Beneficiário",
    "medicos": "Médico",
    "assessor_tecnico": "Assessor Técnico",
    "multiprofissionais": "Multiprofissional",
    //farmacias: "Farmácia",
    //hospitais: "Hospital",
    //clinicas: "Clínica",
    "laboratorio_diagnostico": "Laboratório de Diagnósticos",
    "cooperativas_saude": "Cooperativa de Saúde",
    "motoristas": "Transporte",
    "logistica": "Logística",
    //fornecedor: "Fornecedor",
};

export const tiposEnvio = {
    automatico: "Automático",
    manual: "Manual",        
    ambos: "Ambos",
};

export const momentosEnvio = {
    inicio: "Início",
    termino: "Termino",  
};

export const statusAprovacao = {
    pendente: "Pendente",
    aprovado: "Aprovado",        
    negado: "Negado",
};

export const statusChamados = {
    novo: "Novo",
    andamento: "Em Andamento",
    validacao: "Aguardando Validação",
    concluido: "Concluido",
    cancelado: "Cancelado"
}

export const prioridadeChamados = {
    1: "Alta",
    2: "Média",
    3: "Baixa"
}

export const tiposChamados = {
    "suporte_tecnico": "Suporte Técnico",
    "solicitacao_acesso": "Solicitação de Acesso",
    "erro_integracao": "Erro de Integração",
    "ajuste_cadastro": "Ajuste de Cadastro",
    "duvida_operacional": "Dúvida Operacional",
    "melhoria_evolutiva": "Melhoria / Evolutiva",
    "incidente_critico": "Incidente Crítico"
};

export const descricoesTipos = {
    "suporte_tecnico": "Problemas relacionados ao funcionamento do sistema.",
    "solicitacao_acesso": "Criação, alteração ou exclusão de usuários.",
    "erro_integracao": "Falhas na comunicação entre o CRM e outros sistemas.",
    "ajuste_cadastro": "Correção de informações incorretas em cadastros.",
    "duvida_operacional": "Orientações sobre o uso das funcionalidades.",
    "melhoria_evolutiva": "Pedidos de novas funcionalidades ou ajustes de processo.",
    "incidente_critico": "Falhas graves que impactam o uso global da plataforma."
};

export const categoriasDeProgramas = {
    industria_farmaceutica: "Indústria Farmacêutica",
    plano_saude: "Plano de Saúde",
    governo: "Governo",
    empresa: "Empresa",
    pessoa_fisica: "Pessoa Física"
};

export const tipoUsuarioDashboard = {
    gestor: "Gestor",
    navegador: "Navegador",
    medico: "Médico",
    profissional: "Profissional",
};

export const situacoesAgendamento = {
    solicitado: "Solicitado",
    liberado: "Liberado",
    em_analise: "Em análise",
    finalizado: "Finalizado",
    cancelado: "Cancelado",
    arquivo_pendente: "Arquivo Pendente"
};

export const tiposArquivos = {
    pedido_medico: "Pedido Médico",
    termo: "Termo de Consentimento",
    laudo: "Laudo",
    laudo_evidencia: "Arquivo Evidência",
    exame: "Exame",
    nfe: "NFE",
    comprovante: "Comprovante",
    formulario: "Formulário"
};

export const coberturasTratamento = {
    sus: "SUS",
    saude_suplementar: "Saúde Suplementar",
    sus_saude_suplementar: "SUS e Saúde Suplementar",
    out_of_pocket: "Out of Pocket"
};

export const tiposServicos = {
    servico: "Serviço",
    procedimento: "Procedimento"
};

export const regrasPlanos = {
    produtos: "Produto",
    servicos_procedimentos: "Serviço/Procedimento"
};

export const tiposPaciente = {
    interno: "Interno",
    externo: "Externo",
};

export const statusExamesSelecionados = {
    busca_local: "Em busca de local para realização",
    aguardando_paciente: "Aguardando retorno do paciente",
    aguardando_laboratorio: "Aguardando retorno do laboratório/clínica",
    aguardando_aprovacao: "Aguardando aprovação",
    em_analise: "Em análise",
    pendente: "Pendente",
    aprovado: "Aprovado",
    agendado: "Agendado",
    reagendado: "Reagendado",
    realizado: "Realizado",
    cancelado: "Cancelado",
    recusado: "Recusado",
    stand_by: "Stand By",
    fora_pcdt: "Fora do PCDT"
}

export const statusExame = {
    recusado: "Recusado",
    andamento_pendente_aprovacao: "Andamento - pendente aprovação",
    andamento_aguardando_retorno_paciente: "Andamento - aguardando retorno o paciente",
    andamento_aguardando_retorno_local: "Andamento - aguardando retorno do local",
    em_busca_de_local_para_realizacao: "Em busca de local para realização",
    em_analise: "Em análise",
    pendente: "Pendente",
    agendado: "Agendado",
    realizado: "Realizado",
    realizado_parcial: "Realizado parcial (pendente exames)",
    cancelado: "Cancelado",
    fora_pcdt: "Fora do PCDT",
    stand_by: "Stand By",
}

export const hasPerm = (permission) => {
    const globalValue = JSON.parse(localStorage.getItem('globalContextValue'));
    const userPermissions = globalValue?.user?.permissions || [];

    if(globalValue?.user?.is_superuser){
        return true;
    }

    if(userPermissions.includes(permission)){
        return true;
    }

    return false;
}

export const encryptData = (name, data, storageType = 'cookie') => {
    try {
        const stringifiedData = JSON.stringify(data);
        const encrypted = CryptoJS.AES.encrypt(stringifiedData, SECRET_KEY).toString();

        if (storageType === 'localStorage') {
            localStorage.setItem(name, encrypted);
        } else { // Padrão é cookie
            if (name === 'p') {
                if (encrypted.length > 4000) {
                     console.warn(`<<< [encryptData name='${name}'] WARNING: Size (${encrypted.length}) exceeds typical cookie limits.`);
                }
            }
            Cookies.set(name, encrypted, { secure: true, sameSite: 'Strict', path: '/', expires: 1 });
        }
    } catch (error) {
         console.error(`<<< [encryptData name='${name}'] CRITICAL ERROR during encryption or saving:`, error);
    }
};

export const decryptData = (name, storageType = 'cookie') => {
    let encrypted = null;
    if (storageType === 'localStorage') {
        encrypted = localStorage.getItem(name);
    } else { // Padrão é cookie
        encrypted = Cookies.get(name);
    }


    if (encrypted) {
        try {
            const decryptedBytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
            const decryptedString = decryptedBytes.toString(CryptoJS.enc.Utf8);

            if (!decryptedString) {
                if (name === 'p') return [];
                return null;
            }

            const parsedData = JSON.parse(decryptedString);
            return parsedData;

        } catch (error) {
             console.error(`<<< [decryptData name='${name}'] CRITICAL ERROR during decryption/parsing:`, error);
             if (name === 'p') return [];
             return null;
        }
    }

    if (name === 'p') {
        return [];
    }
    return null;
};

export const getCurrentUser = () => {
    const user = Cookies.get('user');
    const decryptedData = decryptData('o');
    const restricoes = decryptData('r');
    const permissions = decryptData('p', 'localStorage');
    const prog = decryptData('prog');

    if (user && decryptedData) {
        const parsedUser = JSON.parse(user);
        return {
            ...parsedUser,
            ...decryptedData,
            ...prog,
            restricoes: restricoes || [],
            permissions: Array.isArray(permissions) ? permissions : [],
        };
    }
    return null;
};
export const logout = () => {
    TokenService.removeUser();
};

const lista_restricoes_map = {
    "cliente": "Cliente",
    "operador": "Operador",
    "gestor": "Gestor",
    "beneficiario": "Beneficiário",
    "prestador": "Prestador",
    "fornecedor": "Fornecedor",
    "administrador": "Administrador",
};

export const TIPOS_USUARIOS_LISTA = Object.keys(lista_restricoes_map).map(slug => ({
    value: slug,
    label: lista_restricoes_map[slug]
}));

export const tiposAcesso = () => {
    // Descriptografa as restrições do cookie 'r'
    const lista_restricoes_usuario = decryptData('r');

    if (lista_restricoes_usuario) {
        let arr_nova = {};
        for (let i = 0; i < lista_restricoes_usuario.length; i++) {
            let tipo_usuario = lista_restricoes_usuario[i]['tipo_usuario'];
            let operador_id = lista_restricoes_usuario[i]['operador_id'];
            let prestador_id = lista_restricoes_usuario[i]['prestador_id'];
            let gestor_id = lista_restricoes_usuario[i]['gestor_id'];
            let beneficiario_id = lista_restricoes_usuario[i]['beneficiario_id'];
            let tipo_gestor = lista_restricoes_usuario[i]['tipo_gestor'];

            arr_nova[tipo_usuario] = {
                label: lista_restricoes_map[tipo_usuario],
                operador_id: operador_id,
                prestador_id: prestador_id,
                gestor_id: gestor_id,
                beneficiario_id: beneficiario_id,
                tipo_gestor: tipo_gestor,
            };
        }

        return arr_nova;
    }

    return [];
};

export function executeFunctionByName(functionName, context /*, args */) {
    var args = Array.prototype.slice.call(arguments, 2);
    var namespaces = functionName.split(".");
    var func = namespaces.pop();
    for(var i = 0; i < namespaces.length; i++) {
      context = context[namespaces[i]];
    }
    return context[func].apply(context, args);
}

export const localUso = {
    "home_office": "Home Office",
    "escritorio": "Escritório",
    "ambos": "Ambos",
};

export const prestadoresCategorias = {
    "medicos": "Médicos",
    "assessor_tecnico": "Assessor Técnico",
    "multiprofissionais": "Multiprofissionais",
    "farmacias": "Farmácias",
    "hospitais": "Hospitais",
    "clinicas": "Clínicas",
    "plataformas": "Plataformas",
    "laboratorio_diagnostico": "Laboratórios de Diagnósticos",
    "cooperativas_saude": "Cooperativas de Saúde",
    "motoristas": "Transporte",
    "logistica": "Logística"
};

export const tiposSessoesCampos = {
    "0_sem_sessao": "",
    "geral": "Dados gerais",
    "informacoes_relator": "Dados do relator",
    "dados_paciente": "Dados do paciente",
    "medico_prescricao": "Médico prescritor",
    "medico_tratamento": "Médico do tratamento",
    "informacoes_medicamento_suspeito": "Medicamento suspeito",
    "inf_evento_adverso_evento1": "Evento adverso 1",
    "inf_evento_adverso_evento2": "Evento adverso 2",
    "inf_evento_adverso_evento3": "Evento adverso 3",
    "outras_inf_relevantes": "Informações relevantes",
    "queixa_sobre_produto": "Queixa sobre o produto"
}

export const categoriasDeDicas = {
    medicos: "Médico",
    assessor_tecnico: "Assessor Técnico",
    multiprofissionais: "Multiprofissional",
    farmacias: "Farmácia",
    hospitais: "Hospital",
    clinicas: "Clínica",
    plataforma: "Plataforma",
    serviço_diagnostico: "Serviços Diagnósticos",
    laboratorio_diagnostico: "Laboratório de Diagnósticos",
    cooperativas_saude: "Cooperativas de Saúde",
    outros: "Outros",
};

export const categoriasDeGraficos = {
    atendimentos_medicos_mes: "Atendimentos agrupados pelo nome do médico no mês atual",
    atendimentos_ano: "Atendimentos agrupados por ano do ano atual",    
    atendimentos_laboratorios_mes: "Atendimentos agrupados pelo nome do laboratório no mês atual",   
    atendimentos_cidades_mes: "Atendimentos agrupados por cidade e estado dentro do mês",
};

export const tiposGestores = {
    interno: "Interno",
    industria: "Indústria",
}

export const objMeses = {
    1: 'Jan',
    2: 'Fev',
    3: 'Mar',
    4: 'Abr',
    5: 'Mai',
    6: 'Jun',
    7: 'Jul',
    8: 'Ago',
    9: 'Set',
    10: 'Out',
    11: 'Nov',
    12: 'Dez'
}

export const aprovacaoNota = {
    analise: "Análise",
    aprovado: "Aprovado",
    recusado: "Recusado",
}

export const modelosDeMensagem = {
    faturamento_aviso_laboratorio:"Faturamento Aviso Laboratório",
    faturamento_aviso_notafiscal: "Faturamento Aviso Nota Fiscal",
    faturamento_aviso_pagamento: "Faturamento Aviso Pagamento",
    faturamento_aviso_nota_recusada: "Faturamento Aviso Nota Fiscal Recusada",
    importacao_medico: "Importação de Médicos"
}

export const tiposSessoesAtendExtra = {
    "0_sem_sessao": "",
    "geral": "Dados gerais",    
    "detalhes_paciente": "Detalhes Paciente",    
    "tratamento": "Tratamento",    
    "detalhes_prescricao": "Detalhes Prescrição",    
    "observacoes": "Observações",    
    "termos": "Termos",    
    "laudo": "Laudo",    
    "detalhes_acesso": "Detalhes Acesso",    
    "acompanhamento": "Acompanhamento",    
}

export const tratarNulos = (obj) => {
    const novoObjeto = {};
    for (let key in obj) {
        novoObjeto[key] = (obj[key] === null || obj[key] === "null") ? "" : obj[key];
    }
    return novoObjeto;
};

export const calcularTempoNaEtapa = (dataCadastro) => {
    // Converter data de entrada para o fuso horário de São Paulo
    const dataCadastroLocal = new Date(
        new Date(dataCadastro).toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' })
    );

    // Obter a data e hora atual no fuso horário de São Paulo
    const agoraLocal = new Date(
        new Date().toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' })
    );

    // Calcular diferenças detalhadas
    const minutosTotais = differenceInMinutes(agoraLocal, dataCadastroLocal);
    const dias = Math.floor(minutosTotais / (60 * 24));
    const horas = Math.floor((minutosTotais % (60 * 24)) / 60);
    const minutos = minutosTotais % 60;

    if (minutosTotais < 1) {
        return "Menos de 1 minuto";
    }

    let resultado = [];

    // Adicionar dias, horas e minutos dinamicamente
    if (dias > 0) {
        resultado.push(`${dias} dia${dias > 1 ? 's' : ''}`);
    }
    if (horas > 0) {
        resultado.push(`${horas} hora${horas > 1 ? 's' : ''}`);
    }
    if (minutos > 0) {
        resultado.push(`${minutos} minuto${minutos > 1 ? 's' : ''}`);
    }

    // Unir as partes com vírgulas e "e"
    return resultado.length > 1
        ? `${resultado.slice(0, -1).join(', ')} e ${resultado.slice(-1)}`
        : resultado[0];
};

export const isUUID = (str) => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return uuidRegex.test(str);
};
export const formatDateBRtoUS = (data) => {
    if(!data) return '';
    let new_date = data.split("/");
    return new_date[2] + '-' + new_date[1] + '-' + new_date[0];
}

export const formatDateUStoBR = (data) => {
    if(!data) return '';
    let new_date = data.split('T')[0];
    new_date = new_date.split("-");
    return new_date[2] + '/' + new_date[1] + '/' + new_date[0];
}

export const getHour  = (data) => {
    if(!data) return '';
    let new_date = data.split('T')[1];
    new_date = new_date.split(":");
    return new_date[0] + ':' + new_date[1];
}

export function generateUniqueColor(input) {
    // Cria um hash único para a string
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = input.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Converte o hash em valores RGB
  let r = (hash >> 16) & 0xFF;
  let g = (hash >> 8) & 0xFF;
  let b = hash & 0xFF;

  // Calcula a luminosidade relativa (0-255)
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // Se a cor for muito clara, escurece; se for muito escura, clareia
  if (brightness > 200) {
    r = Math.floor(r * 0.8); // Escurece
    g = Math.floor(g * 0.8);
    b = Math.floor(b * 0.8);
  } else if (brightness < 50) {
    r = Math.min(255, Math.floor(r * 1.2)); // Clareia
    g = Math.min(255, Math.floor(g * 1.2));
    b = Math.min(255, Math.floor(b * 1.2));
  }

  // Retorna a cor no formato hexadecimal
  return `rgb(${r}, ${g}, ${b})`;
}
  
export function grupoEtario(dataNascimento) {
    if (!dataNascimento) return '';

    const dataNascimentoObj = new Date(dataNascimento);
    const dataAtual = new Date();

    let idade = dataAtual.getFullYear() - dataNascimentoObj.getFullYear();
    const mes = dataAtual.getMonth() - dataNascimentoObj.getMonth();

    if (mes < 0 || (mes === 0 && dataAtual.getDate() < dataNascimentoObj.getDate())) {
        idade--;
    }

    if (idade >= 0 && idade <= 12) {
        return 'Criança';
    } else if (idade >= 13 && idade <= 17) {
        return 'Adolescente';
    } else if (idade >= 18) {
        return 'Adulto';
    }

    return '';
}

export function isDataFutura(dataBr) {
    if (!dataBr) return false;

    // Separar data e hora
    const [data, hora] = dataBr.split(', '); // "21/06/2025, 08:10"

    // Converter para ISO
    const dataISO = formatDateBRtoUS(data); // "2025-06-21"

    const dataCompletaISO = `${dataISO}T${hora}:00`; // "2025-06-21T08:10:00"

    const dataInformada = new Date(dataCompletaISO);
    const agora = new Date();

    return dataInformada > agora;
}

export function mensagemAlerta(mensagem, tipo = 'warning') {
    const MySwal = withReactContent(Swal);
    switch (tipo) {
        case 'warning':
            MySwal.fire({
                icon: tipo,
                title: 'Atenção!',
                text: mensagem,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            break;
        case 'error':
            MySwal.fire({
                icon: tipo,
                title: 'Erro!',
                text: mensagem,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            break;
        case 'success':
            MySwal.fire({
                icon: tipo,
                title: 'Sucesso!',
                text: mensagem,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Ok'
            });
            break;
    }
}

// valida URL
export function isValidUrl(value) {
  try {
    // a URL lança se não for válida
    new URL(value);
    return true;
  } catch {
    return false;
  }
}

export const motivosAplicacao = {
    // "Farmacovigilância": "Farmacovigilância",
    // "Falta de medicação": "Falta de medicação",    
    // "Fatores independentes": "Fatores independentes",
    // "Falta de medicação": "Falta de medicação",
    "Sem medicação - Falta na farmácia": "Sem medicação - Falta na farmácia",
    "Sem medicação - Logística do paciente  ": "Sem medicação - Logística do paciente",
    "Sem medicação - Pendente atualização de documentação  ": "Sem medicação - Pendente atualização de documentação  ",
    "Decisão do paciente": "Decisão do paciente",
    "Farmacovigilância (Saúde do paciente)": "Farmacovigilância (Saúde do paciente)",
    "Problemas de acesso administrativo/paciente no local de infusão": "Problemas de acesso administrativo/paciente no local de infusão",
    "Decisão do profissional de saúde": "Decisão do profissional de saúde",
    "Falta de aprovação regulatória": "Falta de aprovação regulatória",
    "Relacionado ao pagador": "Relacionado ao pagador",
    "Treinamento/disponibilidade da equipe de infusão": "Treinamento/disponibilidade da equipe de infusão",
    "Feriado": "Feriado",
    "Relacionado à logística": "Relacionado à logística",
    "Restrições impostas federais/estaduais/municipais": "Restrições impostas federais/estaduais/municipais",
    "Nenhum inventário no local de infusão": "Nenhum inventário no local de infusão",
}

export function formatPercent(raw) {
    const num = parseFloat(raw);
    if (isNaN(num)) return '-';
    
    const isInt = Number.isInteger(num);
    return num
        .toLocaleString('pt-BR', {
        minimumFractionDigits: isInt ? 0 : 2,
        maximumFractionDigits: isInt ? 0 : 2
    })
    + '%';
}

export function calcularIdade(dataNascimento) {
    let nascimento;

    if (typeof dataNascimento === 'string') {
        const dataOnly = dataNascimento.split('T')[0];

        if (dataOnly.includes('/')) {
            const [dia, mes, ano] = dataOnly.split('/');
            nascimento = new Date(+ano, +mes - 1, +dia);
        } else if (dataOnly.includes('-')) {
            const [ano, mes, dia] = dataOnly.split('-');
            nascimento = new Date(+ano, +mes - 1, +dia);
        } else {
            nascimento = new Date(dataNascimento);
        }
    } else {
        // já é Date ou timestamp
        nascimento = new Date(dataNascimento);
    }

    const hoje = new Date();
    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const m = hoje.getMonth() - nascimento.getMonth();

    if (m < 0 || (m === 0 && hoje.getDate() < nascimento.getDate())) {
        idade--;
    }
    return idade;
}

export const kitsStatus = {
    agendado: "Agendado",
    enviado: "Enviado",
    cancelado: "Cancelado"
};

const isBusinessDay = (d) => {
  const wd = d.getDay();
  return wd !== 0 && wd !== 6;
};

const isHoliday = (d, holidays = []) => {
  if (!Array.isArray(holidays) || holidays.length === 0) return false;
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  const iso = `${yyyy}-${mm}-${dd}`;
  return holidays.includes(iso);
};

export const addBusinessDays = (startDate, days, holidays = []) => {
  if (!(startDate instanceof Date) || Number.isNaN(startDate)) return null;
  let remaining = Number(days) || 0;
  const out = new Date(startDate.getTime()); // mantém hora

  while (remaining > 0) {
    out.setDate(out.getDate() + 1);
    if (isBusinessDay(out) && !isHoliday(out, holidays)) {
      remaining -= 1;
    }
  }

  return out;
};

export const statusAplicacoes = {
    agendada: "Agendada",
    realizada: "Realizada",
    nao_realizada: "Não Realizada",
    reagendada: "Reagendada",
}

export const formatFileSize = (bytes) => {
    if (bytes === 0 || !bytes) return '0 B';

    const units = ['B', 'KB', 'MB', 'GB', 'TB'];
    const k = 1024;
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return (bytes / Math.pow(k, i)).toFixed(1).replace('.', ',') + ' ' + units[i];
};

/**
 * Substitui variáveis em um texto por valores dinâmicos
 * @param {string} text - Texto com variáveis no formato [nome_variavel]
 * @param {object} variables - Objeto com os valores das variáveis
 * @returns {string} - Texto com as variáveis substituídas
 * 
 * @example
 * replaceTextVariables("Aceito os termos do [programa_nome]", { programa_nome: "Programa X" })
 * // retorna: "Aceito os termos do Programa X"
 */
export const replaceTextVariables = (text, variables = {}) => {
    if (!text || typeof text !== 'string') {
        return text;
    }

    let result = text;

    Object.keys(variables).forEach(key => {
        const regex = new RegExp(`\\[${key}\\]`, 'g');
        const value = variables[key] !== null && variables[key] !== undefined ? variables[key] : '';
        result = result.replace(regex, value);
    });

    return result;
}

/**
 * Verifica se o usuário atual se enquadra em uma lista de perfis configurada
 * em `configuracoes` do programa. Usado pelas regras de bloqueio por perfil.
 *
 * Aliases aceitos na lista:
 *  - `medico` → `medicos`
 *  - `administrador` → `''` (tipo_usuario vazio, equivalente a admin/superuser)
 *
 * Compara contra `tipo_usuario`; quando este é `prestador`, também compara
 * contra `prestador_categoria`.
 */
const matchesPerfilUsuarioAtual = (perfis) => {
    if (!Array.isArray(perfis) || perfis.length === 0) return false;

    const dados_usuario = getCurrentUser();
    const tipoUsuario = dados_usuario?.tipo_usuario || '';
    const perfisNormalizados = perfis.map((p) => {
        if (p === 'medico') return 'medicos';
        if (p === 'administrador') return '';
        return p;
    });

    return perfisNormalizados.includes(tipoUsuario) ||
        (tipoUsuario === 'prestador' && perfisNormalizados.includes(dados_usuario?.prestador_categoria));
};

/**
 * Verifica se a visualização de laudos está bloqueada para o usuário atual
 * conforme as configurações do programa.
 *
 * Configurações suportadas (a nova tem precedência sobre a legada):
 *  - `exames.perfis_bloquear_laudo` (array): bloqueia apenas para os perfis
 *    listados (ver {@link matchesPerfilUsuarioAtual}).
 *  - `bloqueado_visualizar_laudo` (boolean, legado): se true e a chave acima
 *    não estiver definida, bloqueia para todos.
 */
export const isLaudoBloqueadoParaUsuarioAtual = (configuracoes) => {
    const perfisBloqueados = getConfig(configuracoes, 'exames.perfis_bloquear_laudo', null);
    if (Array.isArray(perfisBloqueados)) {
        return matchesPerfilUsuarioAtual(perfisBloqueados);
    }
    return Boolean(getConfig(configuracoes, 'bloqueado_visualizar_laudo', false));
};

/**
 * Verifica se a visualização das respostas/dados da confirmação do serviço
 * está bloqueada para o usuário atual.
 *
 * Configuração: `agendamento.perfis_bloquear_dados_confirmacao_servico` (array
 * de perfis — ver {@link matchesPerfilUsuarioAtual}).
 */
export const isDadosConfirmacaoBloqueadosParaUsuarioAtual = (configuracoes) => {
    const perfisBloqueados = getConfig(
        configuracoes,
        'agendamento.perfis_bloquear_dados_confirmacao_servico',
        null
    );
    return matchesPerfilUsuarioAtual(perfisBloqueados);
};
